import { AuthService } from "./AuthService"
import { clearShopifyOnboardingSession } from "./ShopifyOnboardingSession"
import { clearWooOnboardingSession } from "./WooCommerceOnboardingSession"

const CUSTOM_SESSION_KEY = "customOnboardingSession"
const MERCHANT_OTP_EMAIL_KEY = "zuluMerchantOtpEmail"

export function saveCustomOnboardingSession(session: string): void {
  if (session) {
    sessionStorage.setItem(CUSTOM_SESSION_KEY, session)
  }
}

export function clearCustomOnboardingSession(): void {
  sessionStorage.removeItem(CUSTOM_SESSION_KEY)
}

/**
 * Clears merchant portal / integration sessions and Zulu auth token,
 * then sends the user to the Merchant Portal login.
 */
export function merchantPortalLogout(redirectPath = "/merchant"): void {
  clearShopifyOnboardingSession()
  clearWooOnboardingSession()
  clearCustomOnboardingSession()
  sessionStorage.removeItem(MERCHANT_OTP_EMAIL_KEY)
  AuthService.userLogout()
  window.location.replace(redirectPath)
}
